import { useCourseRedirectLoaderData } from "./courseRedirectLoader.ts";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { CourseDeepLinkState } from "../my-courses/coursesUtils.ts";

export default function CourseRedirect() {
  const { enrolled } = useCourseRedirectLoaderData();
  const params = useParams();
  const navigate = useNavigate();

  // This is being done in the component in order to be able to leverage replace
  // and state. The loader function version only supports basic redirect responses.
  useEffect(() => {
    if (enrolled) {
      void navigate(`/my-courses?termId=${params.term}`, {
        replace: true,
        state: { courseId: params.section } as CourseDeepLinkState,
      });
    } else {
      void navigate(
        `/search/terms/${params.term}/departments/${params.department}/courses/${params.course}/sections/${params.section}`,
        { replace: true }
      );
    }
  }, [enrolled, navigate, params]);

  return null;
}
